import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import i18next from 'i18next';
import { CenteredSpinner } from '@famly/mf_feedback_spinner';
import { useStatFeatures } from '@famly/stat_features_business-logic';
import { useStatPermissions } from '@famly/stat_permissions_business-logic';
/** only exposed for testing */
export const statContext = React.createContext(undefined);
export function useStatContext() {
    return React.use(statContext);
}
export const StatContextProvider = ({ institutionId, employeeId, formId, childId, ratioCalculationConfig, children, }) => {
    const [features, loadingFeatures] = useStatFeatures({ institutionId });
    const statPermissions = useStatPermissions({
        institutionSetId: institutionId,
        employeeId,
        formId,
        childId,
        ratioCalculationConfig: features.newRatioGraphs.isEnabled
            ? (ratioCalculationConfig !== null && ratioCalculationConfig !== void 0 ? ratioCalculationConfig : {
                granularity: 'Continuous',
                ratioSource: 'RoomPriority',
                dataSource: 'BookingsAndShifts',
            })
            : undefined,
    });
    const value = React.useMemo(() => ({
        features,
        permissions: statPermissions.permissions,
        refetchPermissions: statPermissions.refetch,
    }), [features, statPermissions]);
    return (_jsx(statContext.Provider, { value: value, children: loadingFeatures || statPermissions.loading ? (_jsx(CenteredSpinner, { "aria-label": i18next.t($ => $.stat.context.businessLogic.src.translations.json.loadingPermissions) })) : (children) }));
};
